export const infoModalCobros = {
    cancelar: {
        title: "Cancelar operación",
        button: "Confirmar"
    },
    marcar: {
        title: "Marca como cobrado",
        button: "Confirmar"
    }
}